import styled from 'styled-components';
import { device } from '../../../util/commonMediaStylesUtil';

export const YearlyMetricsContainer = styled.div`
  width: 100%;
  max-width: 100%;
  top: 20px;
  left: 20px;
  border: 1px solid #c4c4cd;
  background-color: #ffffff;
  margin: 0 auto;
`;

export const SubHeaderContainer = styled.div`
  justify-content: space-between;
  padding: 15px 20px;
  border: 0px 0px 1px 0px;
  gap: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: auto;
  justify-content: end;
  border-bottom: 1px solid #e1e1e6;
`;

export const TitleDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  height: 35px;
  gap: 10px;
  align-items: center;
  width: 250px;

  ${device.tablet_sm`
    width: 100%;
    flex: unset;
  `}
`;

export const TitleContainer = styled.div`
  height: 24px;
  font-family: EYInterstate;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  color: #000000;

  ${device.phone_sm`
    height: auto;
  `}
`;

export const MetricsContainer = styled.div`
  flex-wrap: wrap;
  justify-content: left;
  padding: 30px 20px 20px 20px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  color: #1a1a24;

  @media (width: 1280px) {
    justify-content: center;
  }

  ${device.laptop_sm`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  `}

  ${device.phone_l`
    gap: 0px 10px;
  `}

  ${device.phone_sm`
    grid-template-columns: repeat(1, 1fr);
  `}
`;

export const ValueContainer = styled.div`
  width: 250px;
  // height: 24px;
  font-family: EYInterstate;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0px;
  flex-direction: row;
  align-items: left;
  @media (width: 1280px) {
    width: 100%;
  }

  ${device.phone_l`
    width: 150px;
  `}
`;

export const LabelContainer = styled.div`
  width: 250px;
  font-family: EYInterstate;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 0px;
  text-align: left;
  @media (width: 1280px) {
    width: 100%;
  }

  ${device.phone_l`
    width: 150px;
 `}
`;

export const SuccessImage = styled.img`
  width: 24px;
  height: 24px;
  margin-left: 8px;
`;

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: #1a1a24;
  padding-bottom: 20px;
`;

export const DataNotAvailable = styled.p`
  font-family: EYInterstate;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0px;
  text-align: center;
  margin: 30px 10px;
`;
